import React, { useState } from 'react';
import { useAppStore } from '../App';

interface SudoBannerProps {
 sudo: {
  asHash: string;
  asName: string | null;
  adminHash: string | null;
  startedAt: string | null;
  mode?: 'view' | 'operate';
 };
}

const SudoBanner: React.FC<SudoBannerProps> = ({ sudo }) => {
 const { setSudo } = useAppStore();
 const [stopping, setStopping] = useState(false);

 const handleStop = async () => {
  if (stopping) return;
  setStopping(true);
  try {
   const r = await fetch('/admin/sudo/stop', { method: 'POST', credentials: 'include' });
   if (r.ok) {
    setSudo(null);
    window.location.reload();
   } else {
    setStopping(false);
    alert('view-as 종료 실패');
   }
  } catch {
   setStopping(false);
   alert('view-as 종료 실패');
  }
 };

 const isOperate = sudo.mode === 'operate';
 const bg = isOperate ? 'bg-amber-600' : 'bg-red-600';
 const btnText = isOperate ? 'text-amber-700' : 'text-red-600';
 const btnHover = isOperate ? 'hover:bg-amber-50' : 'hover:bg-red-50';

 return (
  <div className={`fixed top-0 left-0 right-0 z-[60] ${bg} text-white text-sm flex items-center justify-between px-4 h-8`}>
   <div className="truncate flex-1 min-w-0 mr-2">
    <span className="font-semibold">{isOperate ? '🛠 관리자 운영 위임 모드' : '⚠️ 관리자 view-as 모드'}</span>
    <span className="ml-2 opacity-90">
     {sudo.asName || sudo.asHash} 사용자{isOperate ? '를 대신해 운영 중입니다 — 쓰기 가능 (계정삭제·메시지 제외, 전 작업 기록됨)' : '로 보고 있습니다 — 읽기 전용'}
    </span>
   </div>
   <button
    onClick={handleStop}
    disabled={stopping}
    className={`bg-white ${btnText} ${btnHover} disabled:opacity-50 px-3 py-0.5 text-xs font-semibold`}
   >
    {stopping ? '종료 중...' : '종료'}
   </button>
  </div>
 );
};

export default SudoBanner;
